<template>
    <div>
        <el-form ref="goodsRecoForm" label-width="70px" style="margin-right: 10prx;">       
            <el-form-item v-if="fieldVisible.goodNameEnglish" label="英文名称" style="margin-bottom: 0;">
                <el-input v-model="fieldValue.goodNameEnglish" maxlength="500"></el-input>
            </el-form-item>                   
            <el-form-item v-if="fieldVisible.goodNameChinese" label="中文名称" style="margin-bottom: 0;">
                <el-input v-model="fieldValue.goodNameChinese" maxlength="500"></el-input>
            </el-form-item>             
            <el-form-item v-if="fieldVisible.materialEnglish" label="材质" style="margin-bottom: 0;">
                <el-input v-model="fieldValue.materialEnglish" maxlength="500"></el-input>
            </el-form-item>              
            <el-form-item v-if="fieldVisible.purposeEnglish" label="用途" style="margin-bottom: 0;">
                <el-input v-model="fieldValue.purposeEnglish" maxlength="500"></el-input>
            </el-form-item> 
            <el-form-item v-if="fieldVisible.hsGoodCode" label="商品编码" style="margin-bottom: 0;">
                <el-input v-model="fieldValue.hsGoodCode" maxlength="500"></el-input>
            </el-form-item>              
            <el-form-item v-if="fieldVisible.materialChinese" label="中文材质" style="margin-bottom: 0;">
                <el-input v-model="fieldValue.materialChinese" maxlength="500"></el-input>
            </el-form-item>
            <el-form-item v-if="fieldVisible.purposeChinese" label="中文用途" style="margin-bottom: 0;">
                <el-input v-model="fieldValue.purposeChinese" maxlength="500"></el-input>
            </el-form-item>                                               
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        setting: {
            type: Object
        },
        curField: {
            type: String
        }
    }, 
    data(){
        return{
            goodsRecoKeys:{
                goodNameEnglish: [],
                goodNameChinese: [],
                materialEnglish: [],
                purposeEnglish: [],
                hsGoodCode: [],
                materialChinese: [],
                purposeChinese: []                
            },
            fieldVisible:{
                goodNameEnglish: false,
                goodNameChinese: false,
                materialEnglish: false,
                purposeEnglish: false,
                hsGoodCode: false,
                materialChinese: false,
                purposeChinese: false                 
            },
            fieldValue:{
                goodNameEnglish: '',
                goodNameChinese: '',
                materialEnglish: '',
                purposeEnglish: '',
                hsGoodCode: '',
                materialChinese: '',
                purposeChinese: ''                   
            },
        }
    },
    methods: {
        buildParseKeys(){
            this.goodsRecoKeys.goodNameEnglish = this.setting.goodNameEnglish?this.setting.goodNameEnglish.replace('：', ':').split(/,|，/):[]
            this.goodsRecoKeys.goodNameChinese = this.setting.goodNameChinese?this.setting.goodNameChinese.replace('：', ':').split(/,|，/):[]            
            this.goodsRecoKeys.materialEnglish = this.setting.materialEnglish?this.setting.materialEnglish.replace('：', ':').split(/,|，/):[]
            this.goodsRecoKeys.purposeEnglish = this.setting.purposeEnglish?this.setting.purposeEnglish.replace('：', ':').split(/,|，/):[]
            this.goodsRecoKeys.hsGoodCode = this.setting.hsGoodCode?this.setting.hsGoodCode.replace('：', ':').split(/,|，/):[]
            this.goodsRecoKeys.materialChinese = this.setting.materialChinese?this.setting.materialChinese.replace('：', ':').split(/,|，/):[]      
            this.goodsRecoKeys.purposeChinese = this.setting.purposeChinese?this.setting.purposeChinese.replace('：', ':').split(/,|，/):[]                                 
        },
        getFieldPos(field){
            for(let key of this.goodsRecoKeys[field]){
                if((key) && (key.trim())){
                    let trimKey = key.trim().toUpperCase()
                    let p = this.content.toUpperCase().indexOf(trimKey)
                    if(p >= 0){                        
                        return {
                            name: field,
                            pos: p,
                            key: trimKey
                        }
                    }
                }
            }
            return null
        },
        parseContent(content){
            this.content = content
            console.log(this.curField)
            this.buildParseKeys()
            let positions = []
            for(let field in this.goodsRecoKeys){
                let p = this.getFieldPos(field)
                if(p != null){
                    let pp = positions.find((item)=>item.pos==p.pos)
                    if(pp == null){
                        positions.push(p)
                    }
                }
                this.fieldVisible[field] = false
                this.fieldValue[field] = ''
            }
            let p0 = positions.find((item)=>item.pos==0)
            if(p0 == null){
                positions.push({name: this.curField, pos: 0, key: ''})
            }
            let sortPositions = positions
            if(positions.length > 1){
                sortPositions = positions.sort((a, b)=>b.pos-a.pos)
            }
            let toPos = this.content.length
            for(let position of sortPositions){
                let value = this.content.substring(position.pos + position.key.length, toPos)
                this.$set(this.fieldVisible, position.name, true)
                this.$set(this.fieldValue, position.name, value.trim())
                toPos = position.pos
            }
            console.log(this.fieldVisible)
            console.log(this.fieldValue)
            
        },
        getRecognizedData(){
            return this.fieldValue
        }
    },
}
</script>

<style>
</style>
